import { useWindowSize } from "@/common/hooks/useWindowSize"
import mobileDeviceScreenWidth from "@/constants/mobileDeviceScreenWidth"
import { useAccountTrigger } from "@/hooks/AccountTrigger/useAccountTrigger"
import React, { Suspense } from "react"
import classes from "./accountTrigger.module.css"

const AccountDropMenu = React.lazy(() => import("../AccountDropMenu"))

const AccountTrigger = (props) => {
  const talonProps = useAccountTrigger()
  const {
    accountDropMenuIsOpen,
    accountDropMenuRef,
    accountDropMenuTriggerRef,
    setAccountDropMenuIsOpen,
    handleTriggerClick,
    isUserSignedIn,
  } = talonProps

  const isMobile = useWindowSize().innerWidth < mobileDeviceScreenWidth

  const content =
    isUserSignedIn && !isMobile ? (
      <Suspense fallback={null}>
        <AccountDropMenu />
      </Suspense>
    ) : (
      <button
        className="flex items-center justify-center rounded-[5px] hover_bg-[#F7F7F5] lg_h-[45px] lg_w-[45px]"
        onClick={handleTriggerClick}
      >
        <div className={classes.icon} />
      </button>
    )

  return <div ref={accountDropMenuTriggerRef}>{content}</div>
}

export default AccountTrigger
